module.exports = __webpack_public_path__ + "static/media/empty.daa08157.png";